import { BASE_URL } from '../config';

export const GET_ALLIDO_DETAILS_ENDPOINT = `${BASE_URL}COIN_OWL_UTILS/SEARCH_LIST?limit=10000`;
export const GET_SCROLLING_MESSAGES = `${BASE_URL}COIN_OWL_UTILS/SCROLL_MSGS`;
export const GET_UPCOMINGIDOS_ENDPOINT = (limit, offset) =>
  `${BASE_URL}MV_IDO_TOKENS/MV_UPCOMING_IDO_TOKENS_LIST?limit=${limit}&offset=${offset}`;
export const GET_ONGOINGIDOS_ENDPOINT = (limit, offset) =>
  `${BASE_URL}MV_IDO_TOKENS/MV_ONGOING_IDO_TOKENS_LIST?limit=${limit}&offset=${offset}`;
export const GET_PASTIDOS_ENDPOINT = (limit, offset) =>
  `${BASE_URL}MV_IDO_TOKENS/MV_PAST_IDO_TOKENS_LIST?limit=${limit}&offset=${offset}`;

export const GET_UPCOMINGNFTS_ENDPOINT = (limit, offset) =>
  `${BASE_URL}/MV_NFT_TOKENS/MV_UPCOMING_NFT_LIST?limit=${limit}&offset=${offset}`;
export const GET_ONGOINGNFTS_ENDPOINT = (limit, offset) =>
  `${BASE_URL}/MV_NFT_TOKENS/MV_ONGOING_NFT_LIST?limit=${limit}&offset=${offset}`;
export const GET_PASTINFTS_ENDPOINT = (limit, offset) =>
  `${BASE_URL}/MV_NFT_TOKENS/MV_PAST_NFT_LIST?limit=${limit}&offset=${offset}`;

export const GET_NFT_DETAIL_ENDPOINT = (tokenId) =>
  `${BASE_URL}MV_NFT_TOKENS/MV_NFT_DETAILS/${tokenId}`;
export const GET_IDO_DETAIL_ENDPOINT = `${BASE_URL}MV_IDO_TOKENS/MV_IDO_TOKEN_DETAILS/`;
